import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionReservationBasePolicyPreQuestions as QuestionPreQuestions } from "./pre-questions";

import type { HotelPolicyI18nCategoriesAndManagerStore } from "../../../store/categories";

type Props = {
	reservationQuestionSettings: HotelPolicyI18nCategoriesAndManagerStore["reservationQuestionSettings"];
};

export const QuestionReservationQuestionSettings = ({ reservationQuestionSettings }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={reservationQuestionSettings}>
			<QuestionPreQuestions />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionReservationQuestionSettings.displayName = "QuestionReservationQuestionSettings";
